// extracted by css-extract-rspack-plugin
export default {"visibilityLabel":"Packages-module__visibilityLabel__PRdNx","packageIconWrapper":"Packages-module__packageIconWrapper__xp558","downloadIcon":"Packages-module__downloadIcon__pDSix"};